import Rule from "../Rule";

const disallowedInsuranceSubTypeIds = [
    // Removed these two IHCS payors per Kevin 6/23/2026 - JZ
    // 419, // AvMed - IHCS
    // 182 // CarePlus - IHCS
];

export default class RuleApprovedInsuranceRequiredToEnableDSWOButton extends Rule {
    static message = "DSWO cannot be generated due to unsupported insurance. Send to Business Support.";

    run() {
        const currentChartData = this.currentChartData?.orderActivity?.[this.orderActivityId];

        if (!currentChartData) {
            return this.pass();
        }

        // Business Support can bypass DSWO gating rules.
        // 96 = Business Support: Followup, 116 = Business Support
        if ([96, 116].includes(currentChartData.orderStatusReasonId)) {
            return this.pass();
        }

        if (disallowedInsuranceSubTypeIds.includes(currentChartData.insuranceSubTypeId)) {
            return this.fail();
        }

        return this.pass();
    }
}
